import { createSlice } from "@reduxjs/toolkit";

export const SecurityAlertSlice = createSlice({
  name: "SecurityAlert",
  initialState: {
    securityAlertRecords: [],
    loader: false,
  },
  reducers: {
    getSecurityAlertRecords: (state, action) => {
      state.securityAlertRecords = action.payload;
    },
    showLoader(state) {
      state.loader = true;
    },
    hideLoader(state) {
      state.loader = false;
    },
  },
});

export const { getSecurityAlertRecords, showLoader, hideLoader } =
  SecurityAlertSlice.actions;

export default SecurityAlertSlice.reducer;
